import { useAuth } from "@/contexts/AuthContext";
import { ArrowRight } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function DemoBanner() {
  const { user, exitDemo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!user?.isDemo) return null;

  // Ocultar banner global en páginas de formularios para evitar colisiones visuales
  const isFormPage = /^\/f[1-5]/.test(location.pathname);
  if (isFormPage) return null;

  const handleCreateAccount = () => {
    exitDemo();
    navigate("/");
  };

  return (
    <div
      style={{
        background: "#E3F0F5",
        color: "#00628F",
        padding: "10px 16px",
        fontSize: 13,
        fontWeight: 500,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontFamily: "Inter, sans-serif",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
      data-testid="demo-banner"
    >
      <span className="flex items-center gap-2">
        <span style={{ fontSize: 16 }}>👀</span>
        <span>Estás viendo una cuenta de demostración</span>
      </span>
      <button
        onClick={handleCreateAccount}
        style={{
          background: "#00628F",
          border: "none",
          borderRadius: 8,
          padding: "6px 14px",
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          color: "white",
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
        data-testid="demo-create-account-btn"
      >
        <span>Crear mi cuenta</span>
        <ArrowRight size={14} />
      </button>
    </div>
  );
}
